import { useFeatureFlag } from "Hooks/useFeatureFlag";

export const extensions2dAnd3d = [
  'dwg', 'dxf', 'dgn', 'rvt', 'nwc', 'nwd',
  'ifc', 'dwf', 'dwfx', 'rcp',
];

export const extensions3d = [
  'rvt', 'dwf', 'nwc', 'nwd', 'ifc', 'dwfx',
  'rcp', 'skp',
];

export const allOtherExtensions = [
  'jpg', 'jpeg', 'png', 'tif', 'bmp', 'doc',
  'docx', 'docm', 'ppt', 'pps', 'ppsx', 'ppsm',
  'pptx', 'pptm', 'xls', 'xlsx', 'xlsm', 'rtf',
  'pdf', 'txt', 'html', 'gdoc', 'gsheet', 'gslides',
];

export const extensionsImage = [
  'jpg', 'jpeg', 'png', 'tif', 'bmp', 'webp',
  'gif',
];

export const extensionViews2d3d = ['rvt', 'dwf', 'dwfx', 'ifc', 'rcp', 'skp'];

export const extensionPranchas = ['rvt', 'dwf', 'dwfx'];

export const extensionViewpoints = ['nwc', 'nwd'];

export const COORDLY_2D_VIEWER_EXTENSIONS = ['dwg', 'dxf'];
export const COORDLY_3D_VIEWER_EXTENSIONS = ['ifc', 'gltf', 'glb', 'obj', 'stl'];

export const useCoordlyViewerFeature = () => {
  const coordlyViewerFeatureFlag = useFeatureFlag('coordly-2d-viewer');
  const isCoordlyViewerEnabled = coordlyViewerFeatureFlag.enabled && coordlyViewerFeatureFlag.value === 'test';

  const isCoordly2DViewerEligible = (fileExtension: string) => {
    return isCoordlyViewerEnabled && COORDLY_2D_VIEWER_EXTENSIONS.indexOf(fileExtension.toLocaleLowerCase()) !== -1;
  }

  const isCoordly3DViewerEligible = (fileExtension: string) => {
    return isCoordlyViewerEnabled && COORDLY_3D_VIEWER_EXTENSIONS.indexOf(fileExtension.toLocaleLowerCase()) !== -1;
  }

  const getCoordlyViewerType = (fileExtension: string): '2D' | '3D' | null => {
    if (!isCoordlyViewerEnabled) {
      return null;
    }

    if (isCoordly2DViewerEligible(fileExtension)) {
      return '2D';
    }

    if (isCoordly3DViewerEligible(fileExtension)) {
      return '3D';
    }
    return null;
  }

  return {
    getCoordlyViewerType,
    isCoordly2DViewerEligible,
    isCoordly3DViewerEligible
  }
};

export const isValid3DExtension = (extension: string) => {
  if (extensions3d.indexOf(extension.toLocaleLowerCase()) !== -1) {
    return true;
  }
  return false;
}

export const getFileExtension = (filename: string) => {
  var ext = /^.+\.([^.]+)$/.exec(filename);
  return ext == null ? "" : ext[1];
}
